module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/social.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }